import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, transition } from './glowUtil'
import { DOT_PREFIX } from './constant'

const focusGlow = `0 0 0 2px ${purple[500]}12, 0 0 4px ${purple[500]}08 !important`

export default genComponentStyleHook(['Select', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-selector`]: {
        transition,
        borderRadius: '12px !important',
      },

      [`&${componentCls}-focused ${componentCls}-selector`]: {
        borderColor: `${purple[500]} !important`,
        boxShadow: focusGlow,
      },

      '&:hover': {
        [`${componentCls}-selector`]: {
          borderColor: `${purple[400]} !important`,
        },
      },

      // 下拉菜单项 hover
      [`${componentCls}-item-option-active:not(${componentCls}-item-option-disabled)`]: {
        background: `${purple[500]}10 !important`,
      },
      [`${componentCls}-item-option-selected:not(${componentCls}-item-option-disabled)`]: {
        background: `${purple[500]}18 !important`,
        fontWeight: 600,
      },
    },
  }
})
